import React from "react";
import { Card, Button, Form, Select, Input, Typography } from "antd";
import { FileTextOutlined, HistoryOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
const { Option } = Select;
const { TextArea } = Input;
const ReportIssuesCard = ({
  form,
  formVisible,
  setFormVisible,
  categories,
  questions,
  handleCategoryChange,
  handleCategorySubmit,
  submitting,
  catLoading,
  alertCount,
  memberId,
}) => {
  const navigate = useNavigate();
  return (
    <Card
      loading={catLoading}
      title="Report Issues & Challenges"
      extra={formVisible && <Button onClick={() => setFormVisible(false)}>Close</Button>}
    >
      {!formVisible ? (
        <>
          <h5 style={{ textAlign: "center" }}>📢 Facing any challenges? Let us know!</h5>
          <p style={{ textAlign: "center" }}>
            Share any issues and challenges you’re encountering.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
            <Button type="primary" icon={<FileTextOutlined />} onClick={() => setFormVisible(true)}>
              Share Your Experience
            </Button>
            <Button
              icon={<HistoryOutlined />}
              onClick={() =>
                navigate("/view-history", {
                  state: { memberID: memberId },
                })
              }
            >
              View History &nbsp;
              {alertCount > 0 && <Typography.Text type="danger">{alertCount}</Typography.Text>}
            </Button>
          </div>
        </>
      ) : (
        <Form form={form} layout="vertical" onFinish={handleCategorySubmit}>
          <Form.Item label={<b>Select Category</b>} name="category" rules={[{ required: true }]}>
            <Select placeholder="-- Choose a Category --" onChange={handleCategoryChange}>
              {categories.map((category) => (
                <Option key={category.id} value={category.id}>
                  {category.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          {questions.map((question, index) => (
            <Form.Item
              key={index}
              label={<b>{question}</b>}
              name={`question_${index}`}
              rules={[{ required: true }]}
            >
              <TextArea rows={3} placeholder="Write your response here..." />
            </Form.Item>
          ))}
          <Button type="primary" loading={submitting} disabled={submitting} htmlType="submit">
            {submitting ? "Submitting" : "Submit"}
          </Button>
        </Form>
      )}
    </Card>
  );
};
ReportIssuesCard.propTypes = {
  form: PropTypes.object.isRequired,
  formVisible: PropTypes.bool.isRequired,
  setFormVisible: PropTypes.func.isRequired,
  categories: PropTypes.array.isRequired,
  questions: PropTypes.array.isRequired,
  handleCategoryChange: PropTypes.func.isRequired,
  handleCategorySubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  catLoading: PropTypes.bool.isRequired,
  alertCount: PropTypes.number.isRequired,
  memberId: PropTypes.number.isRequired,
};
export default ReportIssuesCard;
